import { Select } from "antd";
import { RESUME_SECTION_TYPES } from "../../../optimizeResume/editor/config";
import SectionCardShell from "../../../optimizeResume/editor/SectionCardShell";

export default function Skills({ id, data, onChange, onDelete, allCollapsed }) {
  const hard = data?.technicalSkills ?? [];
  const soft = data?.softSkills ?? [];

  return (
    <SectionCardShell
      id={id}
      type={RESUME_SECTION_TYPES.SKILLS}
      data={data}
      onChange={onChange}
      onDelete={onDelete}
      allCollapsed={allCollapsed}
    >
      <div className="flex flex-col gap-3">
        <label className="flex flex-col gap-1 text-sm text-[#475467]">
          <span>Technical skills</span>
          <Select
            mode="tags"
            value={hard}
            onChange={(vals) => onChange({ ...data, technicalSkills: vals })}
            placeholder="Type a skill and press Enter"
            tokenSeparators={[","]}
            style={{ width: "100%" }}
          />
        </label>
        <label className="flex flex-col gap-1 text-sm text-[#475467]">
          <span>Soft skills</span>
          <Select
            mode="tags"
            value={soft}
            onChange={(vals) => onChange({ ...data, softSkills: vals })}
            placeholder="Type a skill and press Enter"
            tokenSeparators={[","]}
            style={{ width: "100%" }}
          />
        </label>
      </div>
    </SectionCardShell>
  );
}
